module.exports = __webpack_public_path__ + "static/media/set_menu.860e7db0.svg";